module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07493_banner_800x600.1051ed97.png";